import { useMemo, useState } from "react";
import games from "../../data/games";

export function fmtTime(sec = 0) {
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return `${m}m ${s.toString().padStart(2, "0")}s`;
}

export function gameNameById(id) {
  const g = games?.find((x) => Number(x.id) === Number(id));
  return g?.name || `Jeu #${id}`;
}

export function teamLabel(s) {
  const t = (s?.teamName || "").trim();
  return t ? t : "Équipe sans nom";
}

export function PlayersBadge({ n }) {
  const label = `${n ?? 0}J`;
  const tone =
    n >= 6 ? "border-fuchsia-400/30 text-fuchsia-200 bg-fuchsia-500/10"
    : n === 5 ? "border-cyan-400/30 text-cyan-200 bg-cyan-500/10"
    : "border-emerald-400/30 text-emerald-200 bg-emerald-500/10";

  return (
    <span className={`inline-flex items-center rounded-xl border px-2 py-1 text-[11px] font-extrabold ${tone}`}>
      {label}
    </span>
  );
}

export function StatPill({ label, value, kind }) {
  const tone =
    kind === "hints" ? "border-amber-400/20 bg-amber-500/10 text-amber-200"
    : kind === "answers" ? "border-amber-600/20 bg-amber-700/10 text-amber-300"
    : kind === "errors" ? "border-rose-400/20 bg-rose-500/10 text-rose-200"
    : "border-white/10 bg-white/5 text-slate-200";

  return (
    <span className={["inline-flex items-center gap-2 rounded-xl border px-2.5 py-1.5 text-[11px] font-semibold", tone].join(" ")}>
      <span className="text-slate-300/70">{label}</span>
      <span className="font-extrabold">{value}</span>
    </span>
  );
}

export function GameFilterDropdown({ value, onChange }) {
  const [open, setOpen] = useState(false);

  const items = useMemo(() => [
    { id: "all", name: "Tous les jeux" },
    ...(games || []).map((g) => ({ id: String(g.id), name: g.name })),
  ], []);

  const current = useMemo(() => {
    const found = items.find((x) => x.id === value);
    return found?.name || "Tous les jeux";
  }, [items, value]);

  return (
    <div className="relative">
      <button type="button" onClick={() => setOpen((v) => !v)}
        className="w-[260px] sm:w-[280px] rounded-2xl border border-white/10 bg-white/5 backdrop-blur px-4 py-3 text-left hover:bg-white/10 transition focus:outline-none focus:ring-2 focus:ring-cyan-400/60">
        <div className="flex items-center justify-between gap-3">
          <div className="min-w-0">
            <p className="text-[10px] uppercase tracking-[0.18em] text-slate-400">Jeu</p>
            <p className="mt-1 text-sm font-semibold text-white truncate">{current}</p>
          </div>
          <span className="shrink-0 rounded-xl border border-white/10 bg-black/30 px-2.5 py-1 text-[11px] font-extrabold text-slate-200">▾</span>
        </div>
      </button>

      {open && (
        <>
          <button type="button" className="fixed inset-0 z-40 cursor-default" onClick={() => setOpen(false)} aria-label="close" />
          <div className="absolute right-0 mt-2 z-50 w-[320px] rounded-2xl border border-white/10 bg-[#0b0b18]/95 backdrop-blur shadow-[0_30px_80px_rgba(0,0,0,0.55)] overflow-hidden">
            <div className="max-h-[320px] overflow-auto p-2">
              {items.map((it) => (
                <button key={it.id} type="button"
                  onClick={() => { onChange(it.id); setOpen(false); }}
                  className={["w-full text-left rounded-xl px-3 py-2.5 transition",
                    it.id === value ? "bg-gradient-to-r from-cyan-600/40 to-indigo-600/40 border border-white/10" : "hover:bg-white/5",
                  ].join(" ")}>
                  <span className="text-sm font-semibold text-white">{it.name}</span>
                </button>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export function ScoreboardBackground() {
  return (
    <div className="pointer-events-none fixed inset-0 opacity-60">
      <div className="absolute -top-32 left-1/2 h-[520px] w-[520px] -translate-x-1/2 rounded-full blur-3xl bg-fuchsia-600/20" />
      <div className="absolute top-40 -left-20 h-[420px] w-[420px] rounded-full blur-3xl bg-cyan-500/15" />
      <div className="absolute bottom-0 right-0 h-[520px] w-[520px] rounded-full blur-3xl bg-indigo-500/15" />
    </div>
  );
}